import { render } from "./WorkflowPayloadEditor.vue?vue&type=template&id=5656016b&scoped=true&ts=true"
import script from "./WorkflowPayloadEditor.vue?vue&type=script&lang=ts"
export * from "./WorkflowPayloadEditor.vue?vue&type=script&lang=ts"

import "./WorkflowPayloadEditor.vue?vue&type=style&index=0&id=5656016b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5656016b"]])

export default __exports__